<!--<mat-dialog-content cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
	<p>
		{{description}}
	</p>
</mat-dialog-content>-->
<tv-section-header [title]="title"></tv-section-header>
<img [src]="imageContent" class="photo-size">
<div class="button-align">
  <button mat-icon-button color="primary" matTooltip="Cancel" style="margin-left: 16%;" (click)="onCancel()">
      <mat-icon style="padding-top: 18%;">cancel</mat-icon>
    </button>
</div>